import { render } from "./Production_Details.vue?vue&type=template&id=2c282016"
import script from "./Production_Details.vue?vue&type=script&lang=js"
export * from "./Production_Details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__